import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import {
  getColorMode,
  onColorModeChange,
  toggleColorMode,
  type ColorMode,
} from '@doo-events/design-tokens/color-mode';

/**
 * Modo claro/escuro do backoffice (design system v2): abre no claro, a escolha fica no
 * navegador. A área do participante (fila e vitrine) NÃO segue o switch — fica sobre a imagem do evento.
 */
export function ColorModeSwitch({ className = '' }: { className?: string }) {
  const [modo, setModo] = useState<ColorMode>(() => getColorMode());
  useEffect(() => onColorModeChange(setModo), []);
  const escuro = modo === 'dark';
  const rotulo = escuro ? 'Usar modo claro' : 'Usar modo escuro';
  return (
    <button
      type="button"
      onClick={() => toggleColorMode()}
      aria-label={rotulo}
      title={rotulo}
      aria-pressed={escuro}
      className={`inline-flex h-[34px] w-[34px] flex-none items-center justify-center rounded-[var(--radius)] text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      {escuro ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}

/** Logo nos dois modos — as duas imagens no DOM, o CSS mostra uma (sem piscar na troca). */
export function LogoDoo({ className = '' }: { className?: string }) {
  return (
    <>
      <img src="/logo-doo.svg" alt="Doo Events" className={`block w-auto dark:hidden ${className}`} />
      <img src="/logo-doo-on-dark.svg" alt="Doo Events" className={`hidden w-auto dark:block ${className}`} />
    </>
  );
}
